(() => {
  const locale = document.documentElement.lang.toLowerCase();

  const spanishTranslations = new Map([
    ['LOW STOCK', 'POCAS UNIDADES'],
    ['IN STOCK', 'DISPONIBLE'],
    ['PRE-ORDER', 'PREVENTA'],
    ['Customer Reviews', 'Reseñas de clientes'],
    ['Track Your Order', 'Rastrear mi pedido'],
    ['SHOP NOW', 'COMPRAR AHORA'],
    ['SHOP NOW!', '¡COMPRAR AHORA!'],
  ]);

  const englishTranslations = new Map([
    ['También te puede gustar', 'You may also like'],
    ['Compra por colección', 'Shop by collection'],
    ['Reseñas de clientes', 'Customer Reviews'],
    ['Rastrear mi pedido', 'Track Your Order'],
  ]);

  const translations = locale.startsWith('es')
    ? spanishTranslations
    : locale.startsWith('en')
      ? englishTranslations
      : new Map();

  if (translations.size === 0) return;

  const selector = '.kk-stock-badge, .jdgm-rev-widg__title, a, button';

  function translateElement(element) {
    const text = element.textContent.trim();
    const translation = translations.get(text);
    if (translation) element.textContent = translation;
  }

  function translate(root) {
    if (root.nodeType !== Node.ELEMENT_NODE && root !== document) return;
    if (root !== document && root.matches?.(selector)) translateElement(root);
    root.querySelectorAll?.(selector).forEach(translateElement);
  }

  translate(document);

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach(translate);
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
